import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "The Cognitive Metrics";
const MAP = [
  { re: /^\/$/, title: `${BASE} - IQ measured with Scientific Precision`, desc: "Unlock your cognitive potential with a scientifically-calibrated online IQ test: 30 credited questions across 5 cognitive domains, instant results, a global percentile ranking and a verifiable certificate. Measure your genius and pursue intellectual greatness." },
  { re: /^\/blog(\/|$)/, title: `IQ & Cognitive Science Blog · ${BASE}`, desc: "Plain-English, science-backed guides on IQ scores, fluid intelligence, brain training and how to measure and improve your reasoning." },
  { re: /^\/instructions/, title: `Start Your IQ Test · ${BASE}`, desc: "30 credited questions, 25 minutes, five cognitive domains. Read the instructions and begin your scientifically-calibrated IQ assessment." },
  { re: /^\/test/, title: `IQ Assessment in Progress · ${BASE}`, desc: "Answer 30 credited IQ questions spanning spatial, fluid, logical, numerical and verbal reasoning." },
  { re: /^\/results/, title: `Your IQ Results · ${BASE}`, desc: "View your IQ score, global percentile, cognitive breakdown and downloadable certificate." },
  { re: /^\/history/, title: `Your Attempt History · ${BASE}`, desc: "Track your IQ score and percentile progress across past assessments." },
  { re: /^\/leaderboard/, title: `Global IQ Leaderboard · ${BASE}`, desc: "See how your IQ ranks anonymously against other test-takers worldwide." },
  { re: /^\/verify/, title: `Verified IQ Result · ${BASE}`, desc: "An independently verifiable certified IQ result from The Cognitive Metrics." },
];

export const RouteSEO = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = MAP.find((x) => x.re.test(pathname)) || MAP[0];
    document.title = m.title;
    const el = document.querySelector('meta[name="description"]');
    if (el) el.setAttribute("content", m.desc);
  }, [pathname]);
  return null;
};
